import React from 'react';

import { i18n } from 'config/locales';
import Subsection from 'components/Section/shared/Subsection';
import { FormDetails } from 'util/singletons';
import {
  SF85, SF85P, SF85PS, SF86
} from 'constants/formTypes';
import { isPVQForm, shouldDisplayCreditFreeze } from 'helpers/form';
import { SignatureValidator } from '../../../validators';
import Signature from './Signature';

export default class Credit extends Subsection {
  constructor(props) {
    super(props);
    this.update = this.update.bind(this);
    this.updateSignature = this.updateSignature.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      Signature: this.props.Signature,
      ...queue,
    });
  }

  updateSignature(values) {
    this.update({ Signature: values });
  }

  render() {
    // Set the singleton Values for use in tests
    const formDetails = FormDetails.getInstance().getData();
    const displayCreditFreeze = shouldDisplayCreditFreeze(formDetails.formType, formDetails.formVersion);

    const isPvq = isPVQForm(formDetails.formType);

    return isPvq ? (
      <div className="credit-release">
        {i18n.m('releasesPvq.credit.contents')}
        <Signature
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props.Signature}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          LegalName={this.props.LegalName}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onError={this.handleError}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onUpdate={this.updateSignature}
        />
      </div>
    ) : (
      <div className="credit-release">
        {(formDetails.formType === SF85)
          && (displayCreditFreeze ? i18n.m('releases.credit.contents85') : i18n.m('releases.credit.contents852024'))}
        {(formDetails.formType === SF85P)
          && (displayCreditFreeze ? i18n.m('releases.credit.contents85p') : i18n.m('releases.credit.contents85p2024'))}
        {(formDetails.formType === SF85PS)
          && (displayCreditFreeze ? i18n.m('releases.credit.contents85ps') : i18n.m('releases.credit.contents85ps2024'))}
        {(formDetails.formType === SF86)
          && (displayCreditFreeze ? i18n.m('releases.credit.contents') : i18n.m('releases.credit.contents2024'))}
        <Signature
          {...this.props.Signature}
          LegalName={this.props.LegalName}
          onUpdate={this.updateSignature} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        />
      </div>
    );
  }
}

Credit.defaultProps = {
  Signature: {},
  LegalName: {},
  section: 'releases',
  subsection: 'credit',
  dispatch: () => { },
  validator: (data) => new SignatureValidator(data).isValid(),
  onUpdate: () => { },
  onError: (value, arr) => arr,
};
